import React, { useEffect, useState } from 'react'

import '../../sass/categories.scss'
import Constants from "../../common/components/constants";
import { Tooltip } from '@mui/material';
import { IconButton } from '@mui/material';
import { TableRow } from '@mui/material';
import TableCell from '@mui/material/TableCell/TableCell';
import { Paper } from '@mui/material';
import { TableContainer } from '@mui/material';
import { Table } from '@mui/material';
import { TableHead } from '@mui/material';
import { Typography } from '@mui/material';
import { TableBody } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

function CategoryRow(props) {

    const [editAuthorized,setEditAuthorized] = useState("")
    const [deleteAuthorized,setDeleteAuthorized] = useState("")

    useEffect(()=>{
        const editAuthorized = (
            props.auth.hasOwnProperty('role') &&
            props.auth.role.hasOwnProperty('EDIT_CATEGORY') &&
            props.auth.role.EDIT_CATEGORY
        );
    
        const deleteAuthorized = (
            props.auth.hasOwnProperty('role') &&
            props.auth.role.hasOwnProperty('DELETE_CATEGORY') &&
            props.auth.role.DELETE_CATEGORY
        );

        setEditAuthorized(editAuthorized)
        setDeleteAuthorized(deleteAuthorized)
        
    },[props.auth])

    const items = props.items.map((item, index) => {
        const editDisabled   = (item.IS_SPECIAL || !editAuthorized);
        const deleteDisabled = (item.IS_SPECIAL || !deleteAuthorized);

        const edit_th = (
            <Tooltip title="編集" aria-label="edit">
                <IconButton aria-label="edit" className="edit"
                            size={"small"}
                            onClick={() => { 
                                if(editDisabled) return;
                                props.editCategory(item); 
                            }}
                            >
                                <EditIcon />
                </IconButton>
            </Tooltip>)

        const delete_th = (
            <Tooltip title="削除" aria-label="delete">
                <IconButton aria-label="delete" className="delete"
                            size={"small"}
                            onClick={() => { 
                                if(deleteDisabled) return;
                                props.deleteCategory(item);
                            }}
                            >
                                <DeleteForeverIcon/>
                </IconButton>
            </Tooltip>)

        return (
            <TableRow key={index}>
                <TableCell className="index">{item.CATEGORY_ID}</TableCell>
                <TableCell>
                    {item.CATEGORY_NAME}
                </TableCell>
                <TableCell >
                    {editDisabled ? "編集不可":  edit_th}
                </TableCell>
                <TableCell >
                    {deleteDisabled ? "削除不可":  delete_th}
                </TableCell>
        </TableRow>
        );
    });

    return (
        <ul className="topics-list">
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: window.innerHeight }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead >
                        <TableRow>
                            <TableCell width={60} sx={{background:"#f8f8f8"}}><Typography fontWeight="540">No</Typography></TableCell>
                            <TableCell  sx={{background:"#f8f8f8"}}>カテゴリ名</TableCell>
                            <TableCell width={100} sx={{background:"#f8f8f8"}}></TableCell>
                            <TableCell width={100} sx={{background:"#f8f8f8"}}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody >
                        {items}
                    </TableBody>
                </Table>
    
            </TableContainer>    
        </Paper>
        
    </ul> );
}

export default CategoryRow

CategoryRow.defaultProps = {
    items: [],
};
